export const COOKIE_NAME = 'accessToken';

export const LOGOUT = 'LOGOUT';
export const GET_APPS = 'GET_APPS';
export const UPDATE_APPS = 'UPDATE_APPS';
export const GET_APP_USERS = 'GET_APP_USERS';

export const REMOVE_ROLES = 'REMOVE_ROLES';
export const ADD_ROLES = 'ADD_ROLES';

export const UPDATE_APP_USERS = 'UPDATE_APP_USERS';
export const GET_ROLES = 'GET_ROLES';
export const FIND_USERS = 'FIND_USERS';
export const UPDATE_FOUND_USERS = 'UPDATE_FOUND_USERS';
export const ADD_USER_TO_APP = 'ADD_USER_TO_APP';
export const REMOVE_USER_FROM_APP = 'REMOVE_USER_FROM_APP';
export const REMOVE_FOUND_USER = 'REMOVE_FOUND_USER';

export const SET_ADMIN_DATA = 'SET_ADMIN_DATA';
export const LOGIN = 'LOGIN';

export const SET_USER_RT_ACTION = 'SET_USER_RT_ACTION';
export const SET_USER_RT_MUTATION = 'SET_USER_RT_MUTATION';



// WEBPACK FOOTER //
// ./src/constants/index.js